import moment from 'moment';
const DATE_RANGES = {
    all: '---',
    today: `&createdAt[gte]=${moment()
        .startOf('day')
        .format()}&createdAt[lt]=${moment()
        .add('1', 'days')
        .startOf('day')
        .format()}`,
    yesterday: `&createdAt[gte]=${moment()
        .subtract('1', 'days')
        .startOf('day')
        .format()}&createdAt[lt]=${moment().startOf('day').format()}`,
    month: `&createdAt[gte]=${moment()
        .startOf('month')
        .format()}&createdAt[lt]=${moment().endOf('month').format()}`,
    pastMonth: `&createdAt[gte]=${moment()
        .subtract('1', 'months')
        .startOf('month')
        .format()}&createdAt[lt]=${moment()
        .subtract('1', 'months')
        .endOf('month')
        .format()}`,
    year: `&createdAt[gte]=${moment()
        .startOf('year')
        .format()}&createdAt[lt]=${moment().endOf('year').format()}`,
    pastYear: `&createdAt[gte]=${moment()
        .subtract('1', 'years')
        .startOf('year')
        .format()}&createdAt[lt]=${moment()
        .subtract('1', 'years')
        .endOf('year')
        .format()}`,
};

export default DATE_RANGES;
